import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import { updateRekvNumber, clearLastVisitedOrderId } from '../../../../../actions/orders'

// Utils
import { translation } from '../../../../../utils/helpers'

// Styles
import './index.scss'
import { hasSubscriptionPermission } from '../../../../../utils/auth'

// Elements
import Text from '../../../../../shared/elements/text'
import LabelWrapper from '../../../../../shared/elements/labelWrapper'

class ChangeRekvNumber extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rekvnumber: undefined
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    if (this.props.item !== undefined) {
      if (this.props.auth.departmentType === 1) {
        this.setState({
          rekvnumber: {
            RekvNumber: this.props.item.BodyShopRekvNumber
          }
        })
      } else {
        this.setState({
          rekvnumber: {
            RekvNumber: this.props.item.RekvNumber
          }
        })
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    let data = {}
    if (this.props.auth.departmentType === 1) {
      data = {
        RekvNumber: nextProps.item.BodyShopRekvNumber
      }
    } else {
      data = {
        RekvNumber: nextProps.item.RekvNumber
      }
    }

    if (!isEqual(data, this.state.rekvnumber)) {
      this.setState({
        rekvnumber: data
      })
    }
  }

  onInputChange (e) {
    let FixInput = e.target.value.replace(',', '.')
    e.persist()
    this.setState({
      rekvnumber: {
        ...this.state.rekvnumber,
        [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : FixInput
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur()
      }
    })
  }

  onBlur () {
    let data = { ...this.state.rekvnumber }

    data.OrderId = this.props.id
    if (this.props.auth.departmentType === 1) {
      data.isBodyShop = true
    } else {
      data.isBodyShop = false
    }

    // console.log(data)

    this.props.updateRekvNumber(data).then((res) => {
      this.props.updateOrder(res.data)
        // Toastr
      // window.toastr.success(translation('2330'), translation('13424'))
    }, () => {
        // Toastr
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  render () {
    const onClick = () => {
      this.props.clearLastVisitedOrderId()
    }
    // console.log(this.state.rekvnumber)
    // console.log(this.props.item)
    if (this.state.rekvnumber === undefined) {
      return null
    } else {
      // popup isn't shown anywhere!
      if (this.props.showLabel === true || this.props.showLabel === undefined) {
        return (
          <div className='poppedup padding colorInlinePopup form'>
            <LabelWrapper labelText={translation('80')}>
              {hasSubscriptionPermission(this.props.auth, 10) && (
              <Text size='m' name='RekvNumber' value={this.state.rekvnumber.RekvNumber || ''} onChange={this.onInputChange} onBlur={this.onBlur} onClick={onClick} />
              )}
            </LabelWrapper>
          </div>
        )
      } else {
        return (
          <div>
            <div>
              {hasSubscriptionPermission(this.props.auth, 10) && (
                <Text size='s' name='RekvNumber' value={this.state.rekvnumber.RekvNumber || ''} onChange={this.onInputChange} onBlur={this.onBlur} onClick={onClick} />
              )}
            </div>
          </div>
        )
      }
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  updateRekvNumber,
  clearLastVisitedOrderId
})(ChangeRekvNumber)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/RekvNumber/index.js